// removed by extract-text-webpack-plugin
module.exports = {"content":"Modal-style__content__47dddec1"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Modal-style.scss
// module id = 547
// module chunks = 4 5 7 8 10 36